import { useState, useEffect } from 'react';
import { useApi } from '../hooks/useApi';
import { money } from '../events/util';

// Módulo Inventario. Pantallas: Ítems · Recetas · (próx.) Recepción · Conteo · Consumo.
export default function Inventario() {
  const [tab, setTab] = useState('items');
  return (
    <div className="lb-fade" style={{ paddingTop: 16 }}>
      <div className="lb-subtabs">
        <button className={tab === 'items' ? 'active' : ''} onClick={() => setTab('items')}>Stock</button>
        <button className={tab === 'proveedores' ? 'active' : ''} onClick={() => setTab('proveedores')}>Proveedores</button>
        <button className={tab === 'recetas' ? 'active' : ''} onClick={() => setTab('recetas')}>Recetas</button>
        <button className={tab === 'recepcion' ? 'active' : ''} onClick={() => setTab('recepcion')}>Recepción</button>
        <button className={tab === 'conteo' ? 'active' : ''} onClick={() => setTab('conteo')}>Conteo físico</button>
        <button className={tab === 'pedidos' ? 'active' : ''} onClick={() => setTab('pedidos')}>Pedidos</button>
        <button className={tab === 'consumo' ? 'active' : ''} onClick={() => setTab('consumo')}>Consumo</button>
        <button className={tab === 'alertas' ? 'active' : ''} onClick={() => setTab('alertas')}>Alertas</button>
      </div>
      {tab === 'items' && <Items />}
      {tab === 'proveedores' && <Proveedores />}
      {tab === 'recetas' && <Recetas />}
      {tab === 'recepcion' && <Recepcion />}
      {tab === 'conteo' && <Conteo />}
      {tab === 'pedidos' && <Pedidos />}
      {tab === 'consumo' && <Consumo />}
      {tab === 'alertas' && <Alertas />}
    </div>
  );
}

/* ─────────────────────────── ÍTEMS ─────────────────────────── */
function Items() {
  const api = useApi();
  const [items, setItems] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: '', unit: 'unidad', cost: '', reorder_point: '', stock_inicial: '', supplier_id: '' });
  const [editing, setEditing] = useState(null);
  const [err, setErr] = useState('');

  const load = () => { setLoading(true); api.get('/api/inventory/items').then(r => setItems(Array.isArray(r) ? r : [])).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { load(); api.get('/api/inventory/suppliers').then(r => setSuppliers((Array.isArray(r) ? r : []).filter(s => s.active))).catch(() => {}); }, []); // eslint-disable-line

  async function setSupplier(it, supplier_id) {
    try { await api.patch(`/api/inventory/items/${it.id}`, { supplier_id: supplier_id || null }); load(); }
    catch (e) { alert(e.message); }
  }

  async function create() {
    setErr('');
    if (!form.name.trim()) { setErr('Poné un nombre'); return; }
    try {
      await api.post('/api/inventory/items', { name: form.name.trim(), unit: form.unit.trim() || 'unidad', cost: Number(form.cost) || 0, reorder_point: Number(form.reorder_point) || 0, stock_inicial: Number(form.stock_inicial) || 0, supplier_id: form.supplier_id || null });
      setForm({ name: '', unit: 'unidad', cost: '', reorder_point: '', stock_inicial: '', supplier_id: '' });
      load();
    } catch (e) { setErr(e.message || 'No se pudo crear'); }
  }
  async function saveEdit() {
    try { await api.patch(`/api/inventory/items/${editing.id}`, { name: editing.name, unit: editing.unit, cost: Number(editing.cost) || 0, reorder_point: Number(editing.reorder_point) || 0 }); setEditing(null); load(); }
    catch (e) { alert('No se pudo guardar: ' + e.message); }
  }
  async function deactivate(it) {
    if (!window.confirm(`¿Dar de baja "${it.name}"? Se conserva el historial de movimientos.`)) return;
    try { await api.del(`/api/inventory/items/${it.id}`); load(); } catch (e) { alert(e.message); }
  }
  const low = it => it.active && Number(it.stock) <= Number(it.reorder_point) && Number(it.reorder_point) > 0;

  return (
    <div className="lb-fade" style={{ marginTop: 18 }}>
      <p style={{ color: 'var(--ink-700)', fontSize: 13, marginTop: 0 }}>Lo que se compra y se cuenta en unidades cerradas. Stock continuo; solo cambia por movimientos (recepción, venta, ajuste).</p>
      <div className="lb-card" style={{ padding: '18px 20px', marginBottom: 22 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 0.7fr 0.8fr 0.8fr 0.8fr 1.1fr auto', gap: 10, alignItems: 'end' }}>
          <Field label="Nombre"><input className="lb-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Fernet 750" /></Field>
          <Field label="Unidad"><input className="lb-input" value={form.unit} onChange={e => setForm({ ...form, unit: e.target.value })} placeholder="botella" /></Field>
          <Field label="Costo"><input className="lb-input" inputMode="numeric" value={form.cost} onChange={e => setForm({ ...form, cost: e.target.value })} placeholder="0" /></Field>
          <Field label="Alerta (pedir)"><input className="lb-input" inputMode="numeric" value={form.reorder_point} onChange={e => setForm({ ...form, reorder_point: e.target.value })} placeholder="0" /></Field>
          <Field label="Stock inicial"><input className="lb-input" inputMode="numeric" value={form.stock_inicial} onChange={e => setForm({ ...form, stock_inicial: e.target.value })} placeholder="0" /></Field>
          <Field label="Proveedor">
            <select className="lb-select" value={form.supplier_id} onChange={e => setForm({ ...form, supplier_id: e.target.value })}>
              <option value="">— Sin proveedor —</option>
              {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </Field>
          <button className="lb-btn lb-btn--primary" onClick={create}>Agregar</button>
        </div>
        {suppliers.length === 0 && (
          <div style={{ marginTop: 10, fontSize: 11.5, color: 'var(--ink-600)' }}>
            Todavía no hay proveedores cargados: cargalos en la pestaña <b>Proveedores</b>. El ítem se puede crear sin proveedor y asignárselo después.
          </div>
        )}
        {err && <div className="lb-err" style={{ marginTop: 10 }}>{err}</div>}
      </div>
      <div className="lb-card tk-scroll-x" style={{ padding: '6px 22px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '1.6fr 0.7fr 0.8fr 0.8fr 0.8fr 1.3fr 0.9fr' }}>
          <span>Ítem</span><span>Unidad</span><span>Stock</span><span>Costo</span><span>Alerta</span><span>Proveedor</span><span></span>
        </div>
        {loading && <div style={{ padding: '20px 0', color: 'var(--ink-600)', fontSize: 13 }}>Cargando…</div>}
        {!loading && items.length === 0 && <div style={{ padding: '24px 0', color: 'var(--ink-600)', fontSize: 13, textAlign: 'center' }}>Todavía no hay ítems. Agregá el primero arriba.</div>}
        {items.map(it => (
          <div key={it.id} className="lb-row" style={{ gridTemplateColumns: '1.6fr 0.7fr 0.8fr 0.8fr 0.8fr 1.3fr 0.9fr', opacity: it.active ? 1 : 0.5 }}>
            <span style={{ color: '#fff', fontWeight: 600 }}>{it.name}{!it.active && <span style={{ color: 'var(--ink-600)', fontWeight: 400 }}> · baja</span>}</span>
            <span style={{ color: 'var(--ink-700)' }}>{it.unit}</span>
            <span style={{ color: low(it) ? 'var(--red-400)' : '#fff', fontWeight: 600 }}>{Number(it.stock)}{low(it) ? ' ⚠' : ''}</span>
            <span style={{ color: 'var(--ink-800)' }}>{money(it.cost)}</span>
            <span style={{ color: 'var(--ink-700)' }}>{Number(it.reorder_point) || '—'}</span>
            <span>
              <select className="lb-select" style={{ padding: '6px 24px 6px 8px', fontSize: 12, width: '100%' }} value={it.supplier_id || ''} onChange={e => setSupplier(it, e.target.value)}>
                <option value="">— Sin proveedor —</option>
                {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </span>
            <span style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setEditing({ ...it })}>Editar</button>
              {it.active && <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => deactivate(it)}>Baja</button>}
            </span>
          </div>
        ))}
      </div>
      <div className="lb-card" style={{ marginTop: 14, padding: '18px 22px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
        <div>
          <div className="lb-eyebrow">Valor del stock</div>
          <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 4 }}>Suma de cantidad × costo de cada ítem activo. La plata que tenés inmovilizada en stock.</div>
        </div>
        <span style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 30, color: '#fff' }}>
          {money(items.filter(it => it.active).reduce((a, it) => a + Number(it.stock || 0) * Number(it.cost || 0), 0))}
        </span>
      </div>
      <div style={{ marginTop: 10, fontSize: 11, color: 'var(--ink-600)' }}>El stock no se edita a mano: cambia por recepción, venta del TPV o ajuste con motivo.</div>

      {editing && (
        <div className="lb-modal-backdrop" onClick={() => setEditing(null)}>
          <div className="lb-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 420, padding: 24 }}>
            <div className="lb-h" style={{ fontSize: 18, marginBottom: 14 }}>Editar ítem</div>
            <Field label="Nombre"><input className="lb-input" value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} /></Field>
            <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
              <Field label="Unidad"><input className="lb-input" value={editing.unit} onChange={e => setEditing({ ...editing, unit: e.target.value })} /></Field>
              <Field label="Costo"><input className="lb-input" inputMode="numeric" value={editing.cost} onChange={e => setEditing({ ...editing, cost: e.target.value })} /></Field>
              <Field label="Alerta"><input className="lb-input" inputMode="numeric" value={editing.reorder_point} onChange={e => setEditing({ ...editing, reorder_point: e.target.value })} /></Field>
            </div>
            <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 10 }}>Stock actual: <b style={{ color: '#fff' }}>{Number(editing.stock)}</b> (no editable acá)</div>
            <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
              <button className="lb-btn lb-btn--primary lb-btn--block" onClick={saveEdit}>Guardar</button>
              <button className="lb-btn lb-btn--ghost lb-btn--block" onClick={() => setEditing(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────── RECETAS ─────────────────────────── */
function Recetas() {
  const api = useApi();
  const [products, setProducts] = useState([]);
  const [items, setItems] = useState([]);
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [draft, setDraft] = useState({}); // { [productId]: { item_id, yield } }
  const [editandoPrecio, setEditandoPrecio] = useState(null); // { id, valor }

  const load = () => {
    setLoading(true);
    Promise.all([
      api.get('/api/tpv/products').then(r => Array.isArray(r) ? r : []).catch(() => []),
      api.get('/api/inventory/items').then(r => (Array.isArray(r) ? r : []).filter(i => i.active)).catch(() => []),
      api.get('/api/inventory/recipes').then(r => Array.isArray(r) ? r : []).catch(() => []),
    ]).then(([p, i, rec]) => { setProducts(p.filter(x => x.active !== false)); setItems(i); setRecipes(rec); }).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const byProduct = {};
  recipes.forEach(r => { (byProduct[r.product_id] = byProduct[r.product_id] || []).push(r); });

  // Productos sin receta. La lista NO se reordena: al vincular el primer ingrediente el
  // producto dejaba de estar "sin receta" y saltaba de lugar, justo cuando todavía le
  // faltan ingredientes por cargar. Mientras se trabaja, el orden tiene que quedar quieto.
  const faltantes = products.filter(p => !(byProduct[p.id] || []).length);

  // Costo de un ingrediente en UNA venta: lo que cuesta la unidad del ítem dividido su
  // rinde. Una botella de $10.000 que rinde 5 pone $2.000 por trago; una lata que rinde
  // 1 pone su precio entero.
  //
  // Devuelve null (no 0) si el ítem no tiene costo cargado: un total en $0 se lee como
  // "no me cuesta nada" cuando en realidad es "no lo sé", y esa diferencia es la que
  // hace que alguien fije un precio mal.
  const costoLinea = (l) => {
    const costo = Number(l.item_cost);
    const rinde = Number(l.yield) || 1;
    if (!Number.isFinite(costo) || costo <= 0 || rinde <= 0) return null;
    return costo / rinde;
  };

  async function addLine(productId) {
    const d = draft[productId] || {};
    if (!d.item_id) return alert('Elegí un ítem');
    const y = Number(d.yield) || 1;
    if (!(y > 0)) return alert('El rinde debe ser mayor a 0');
    try { await api.post('/api/inventory/recipes', { product_id: productId, inventory_item_id: d.item_id, yield: y }); setDraft({ ...draft, [productId]: { item_id: '', yield: '' } }); load(true); }
    catch (e) { alert('No se pudo: ' + e.message); }
  }
  async function setYield(line, y) {
    const v = Number(y); if (!(v > 0)) return;
    try { await api.patch(`/api/inventory/recipes/${line.id}`, { yield: v }); setRecipes(rs => rs.map(r => r.id === line.id ? { ...r, yield: v } : r)); }
    catch (e) { alert(e.message); }
  }
  async function removeLine(line) {
    try { await api.del(`/api/inventory/recipes/${line.id}`); load(true); } catch (e) { alert(e.message); }
  }

  // Cambiar el precio de venta sin salir de Recetas: el margen se ve acá, así que la
  // decisión de subir el precio se toma acá. Ir hasta Cajas TPV, buscar el producto y
  // volver es donde se pierde el hilo de lo que estabas revisando.
  //
  // Se actualiza el producto en memoria en vez de recargar todo: recargar desmonta la
  // lista y manda la página arriba, el mismo problema que tenía "Vincular".
  async function guardarPrecio(prod, valor) {
    const nuevo = Number(String(valor).replace(/[^\d.]/g, ''));
    if (!Number.isFinite(nuevo) || nuevo < 0) { alert('Poné un precio válido'); return; }
    if (nuevo === Number(prod.price)) { setEditandoPrecio(null); return; }
    try {
      await api.patch(`/api/tpv/products/${prod.id}`, { price: nuevo });
      setProducts(ps => ps.map(x => x.id === prod.id ? { ...x, price: nuevo } : x));
      setEditandoPrecio(null);
    } catch (e) { alert('No se pudo guardar: ' + e.message); }
  }

  if (loading) return <div style={{ padding: '24px 0', color: 'var(--ink-600)', fontSize: 13 }}>Cargando…</div>;

  return (
    <div className="lb-fade" style={{ marginTop: 18 }}>
      <p style={{ color: 'var(--ink-700)', fontSize: 13, marginTop: 0 }}>Definí qué ítem(s) de inventario descuenta cada producto del TPV y su <b>rinde</b>: si una botella rinde 5 servidas, poné rinde 5 (cada venta descuenta 1/5). Un producto puede descontar de varios ítems.</p>
      {products.length === 0 && <div className="lb-card" style={{ padding: 22, textAlign: 'center', color: 'var(--ink-600)', fontSize: 13 }}>No hay productos de TPV cargados. Creálos en “Cajas TPV”.</div>}
      {items.length === 0 && products.length > 0 && <div className="lb-card" style={{ padding: 16, color: 'var(--ink-700)', fontSize: 13, marginBottom: 14 }}>Primero cargá ítems de inventario (pestaña Ítems) para poder vincularlos.</div>}

      {/* Cuántos faltan, arriba: con la lista larga, marcar en rojo no alcanza si hay que
          recorrerla toda para saber si queda alguno. Los faltantes van primero. */}
      {faltantes.length > 0 && (
        <div className="lb-card" style={{ padding: '14px 18px', marginBottom: 14, border: '1px solid rgba(200,16,46,0.55)', background: 'rgba(200,16,46,0.08)' }}>
          <div style={{ color: 'var(--red-400)', fontWeight: 700, fontSize: 13 }}>
            {faltantes.length} {faltantes.length === 1 ? 'producto sin receta' : 'productos sin receta'}
          </div>
          <div style={{ fontSize: 12, color: 'var(--ink-700)', marginTop: 4, lineHeight: 1.5 }}>
            Se venden igual, pero <b>no descuentan stock</b>: el inventario va a quedar más alto que la realidad y no van a entrar en los pedidos.
            {' '}Los que faltan: {faltantes.slice(0, 6).map(x => x.name).join(', ')}{faltantes.length > 6 ? ` y ${faltantes.length - 6} más` : ''}.
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {products.map(p => {
          const lines = byProduct[p.id] || [];
          const d = draft[p.id] || {};
          const sinReceta = lines.length === 0;
          return (
            <div key={p.id} className="lb-card" style={{ padding: '16px 20px', border: sinReceta ? '1px solid rgba(200,16,46,0.55)' : undefined, background: sinReceta ? 'rgba(200,16,46,0.06)' : undefined }}>
              {/* Sin receta = ese producto se vende sin descontar stock, así que el
                  inventario miente sin avisar. Se marca en rojo (título + borde + chapa)
                  para que se vea de un saltito de ojo entre veinte productos correctos. */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 10, gap: 12, flexWrap: 'wrap' }}>
                <div style={{ color: sinReceta ? 'var(--red-400)' : '#fff', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  {p.name}
                  <span style={{ color: 'var(--ink-600)', fontSize: 12, fontWeight: 400 }}>· {p.category} ·</span>
                  {editandoPrecio?.id === p.id ? (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                      <input className="lb-input" style={{ width: 110, padding: '5px 8px', fontSize: 13 }} inputMode="numeric" autoFocus
                        value={editandoPrecio.valor}
                        onChange={e => setEditandoPrecio({ id: p.id, valor: e.target.value.replace(/[^\d]/g, '') })}
                        onKeyDown={e => { if (e.key === 'Enter') guardarPrecio(p, editandoPrecio.valor); if (e.key === 'Escape') setEditandoPrecio(null); }} />
                      <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={() => guardarPrecio(p, editandoPrecio.valor)}>Guardar</button>
                      <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setEditandoPrecio(null)}>Cancelar</button>
                    </span>
                  ) : (
                    <button onClick={() => setEditandoPrecio({ id: p.id, valor: String(Math.round(Number(p.price) || 0)) })}
                      title="Cambiar el precio de venta"
                      style={{ background: 'transparent', border: '1px solid var(--border)', borderRadius: 999, padding: '3px 10px', color: '#fff', fontSize: 12.5, cursor: 'pointer', fontFamily: 'inherit' }}>
                      {money(p.price)} <span style={{ color: 'var(--ink-600)' }}>✎</span>
                    </button>
                  )}
                </div>
                {sinReceta && (
                  <span style={{ fontSize: 10.5, letterSpacing: '0.08em', textTransform: 'uppercase', fontWeight: 700, color: 'var(--red-400)', border: '1px solid var(--red-400)', borderRadius: 999, padding: '3px 10px', whiteSpace: 'nowrap' }}>
                    ⚠ Falta la receta · no descuenta stock
                  </span>
                )}
              </div>
              {lines.map(l => {
                const c = costoLinea(l);
                return (
                  <div key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                    <span style={{ flex: 1, color: '#fff', fontSize: 14 }}>{l.item_name} <span style={{ color: 'var(--ink-600)', fontSize: 12 }}>({l.item_unit})</span></span>
                    <span style={{ fontSize: 12, color: 'var(--ink-700)' }}>rinde</span>
                    <input className="lb-input" style={{ width: 70 }} inputMode="numeric" defaultValue={Number(l.yield)} onBlur={e => setYield(l, e.target.value)} />
                    <span style={{ fontSize: 11, color: 'var(--ink-600)', width: 130 }}>descuenta {(1 / Number(l.yield)).toFixed(2)} / venta</span>
                    {/* Costo de ESTE ingrediente en una venta: costo del ítem ÷ rinde. */}
                    <span style={{ width: 120, textAlign: 'right', fontSize: 13, color: c === null ? 'var(--ink-600)' : '#fff', fontWeight: c === null ? 400 : 600 }}>
                      {c === null ? 'sin costo' : money(Math.round(c))}
                    </span>
                    <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => removeLine(l)}>Quitar</button>
                  </div>
                );
              })}

              {/* Costo total de la receta y qué queda del precio de venta. Con el precio
                  justo al lado, ver el costo sin el margen invita a hacer la resta a mano. */}
              {lines.length > 0 && (() => {
                const costos = lines.map(costoLinea);
                const faltan = costos.some(c => c === null);
                const total = costos.reduce((a, c) => a + (c || 0), 0);
                const precio = Number(p.price) || 0;
                const margen = precio - total;
                const pct = precio > 0 ? Math.round(margen / precio * 100) : 0;
                return (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 16, flexWrap: 'wrap', paddingTop: 10, marginTop: 4, borderTop: '1px solid rgba(255,255,255,0.14)' }}>
                    <span style={{ fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink-700)' }}>Costo de la receta</span>
                    <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, color: '#fff' }}>{money(Math.round(total))}</span>
                    {precio > 0 && !faltan && (
                      <span style={{ fontSize: 12, color: margen < 0 ? 'var(--red-400)' : 'var(--ink-700)' }}>
                        se vende a {money(precio)} · queda <b style={{ color: margen < 0 ? 'var(--red-400)' : '#fff' }}>{money(Math.round(margen))}</b> ({pct}%)
                      </span>
                    )}
                    {faltan && <span style={{ fontSize: 11.5, color: 'var(--red-300)' }}>Falta el costo de algún ítem: el total está incompleto.</span>}
                  </div>
                );
              })()}
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 10 }}>
                <select className="lb-select" style={{ flex: 1 }} value={d.item_id || ''} onChange={e => setDraft({ ...draft, [p.id]: { ...d, item_id: e.target.value } })}>
                  <option value="">+ Agregar ítem…</option>
                  {items.filter(i => !lines.some(l => l.inventory_item_id === i.id)).map(i => <option key={i.id} value={i.id}>{i.name} ({i.unit})</option>)}
                </select>
                <input className="lb-input" style={{ width: 90 }} inputMode="numeric" placeholder="rinde" value={d.yield || ''} onChange={e => setDraft({ ...draft, [p.id]: { ...d, yield: e.target.value } })} />
                <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => addLine(p.id)} disabled={!d.item_id}>Vincular</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ─────────────────────────── RECEPCIÓN ─────────────────────────── */
function Recepcion() {
  const api = useApi();
  const [items, setItems] = useState([]);
  const [recs, setRecs] = useState([]);
  const [f, setF] = useState({ inventory_item_id: '', qty: '', cost: '', note: '' });
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => {
    api.get('/api/inventory/items').then(r => setItems((Array.isArray(r) ? r : []).filter(i => i.active))).catch(() => {});
    api.get('/api/inventory/movements?type=reception&limit=50').then(r => setRecs(Array.isArray(r) ? r : [])).catch(() => {});
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const pickItem = id => { const it = items.find(x => x.id === id); setF({ ...f, inventory_item_id: id, cost: it && Number(it.cost) ? String(it.cost) : f.cost }); };

  async function submit() {
    setErr('');
    if (!f.inventory_item_id) { setErr('Elegí un ítem'); return; }
    if (!(Number(f.qty) > 0)) { setErr('Cantidad mayor a 0'); return; }
    setSaving(true);
    try {
      await api.post('/api/inventory/receptions', { inventory_item_id: f.inventory_item_id, qty: Number(f.qty), cost: f.cost === '' ? null : Number(f.cost), note: f.note.trim() || null });
      setF({ inventory_item_id: '', qty: '', cost: '', note: '' });
      load();
    } catch (e) { setErr(e.message || 'No se pudo registrar'); } finally { setSaving(false); }
  }
  const fmt = d => { try { return new Date(d).toLocaleString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires' }); } catch { return ''; } };

  return (
    <div className="lb-fade" style={{ marginTop: 18 }}>
      <p style={{ color: 'var(--ink-700)', fontSize: 13, marginTop: 0 }}>Cargá las entradas de mercadería: <b>suben el stock</b> y quedan registradas (cantidad, costo, fecha, quién). El costo actualiza el del ítem.</p>
      <div className="lb-card" style={{ padding: '18px 20px', marginBottom: 22 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.8fr 0.8fr 0.9fr 1.4fr auto', gap: 10, alignItems: 'end' }}>
          <Field label="Ítem">
            <select className="lb-select" value={f.inventory_item_id} onChange={e => pickItem(e.target.value)}>
              <option value="">Elegí…</option>
              {items.map(i => <option key={i.id} value={i.id}>{i.name} ({i.unit}) · stock {Number(i.stock)}</option>)}
            </select>
          </Field>
          <Field label="Cantidad"><input className="lb-input" inputMode="numeric" value={f.qty} onChange={e => setF({ ...f, qty: e.target.value })} placeholder="0" /></Field>
          <Field label="Costo unit."><input className="lb-input" inputMode="numeric" value={f.cost} onChange={e => setF({ ...f, cost: e.target.value })} placeholder="0" /></Field>
          <Field label="Nota (remito, proveedor…)"><input className="lb-input" value={f.note} onChange={e => setF({ ...f, note: e.target.value })} placeholder="opcional" /></Field>
          <button className="lb-btn lb-btn--primary" onClick={submit} disabled={saving}>{saving ? '…' : 'Registrar'}</button>
        </div>
        {err && <div className="lb-err" style={{ marginTop: 10 }}>{err}</div>}
      </div>

      <div className="lb-eyebrow" style={{ marginBottom: 10 }}>Últimas recepciones</div>
      <div className="lb-card tk-scroll-x" style={{ padding: '6px 22px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '1.6fr 0.7fr 0.9fr 1.3fr 1.2fr' }}>
          <span>Ítem</span><span>Cant.</span><span>Costo</span><span>Fecha</span><span>Quién</span>
        </div>
        {recs.length === 0 && <div style={{ padding: '22px 0', color: 'var(--ink-600)', fontSize: 13, textAlign: 'center' }}>Sin recepciones todavía.</div>}
        {recs.map(m => (
          <div key={m.id} className="lb-row" style={{ gridTemplateColumns: '1.6fr 0.7fr 0.9fr 1.3fr 1.2fr' }}>
            <span style={{ color: '#fff' }}>{m.item_name} <span style={{ color: 'var(--ink-600)', fontSize: 12 }}>({m.item_unit})</span></span>
            <span style={{ color: '#2ecc71', fontWeight: 600 }}>+{Number(m.qty)}</span>
            <span style={{ color: 'var(--ink-800)' }}>{m.cost != null ? money(m.cost) : '—'}</span>
            <span style={{ color: 'var(--ink-700)', fontSize: 12 }}>{fmt(m.created_at)}</span>
            <span style={{ color: 'var(--ink-700)', fontSize: 12 }}>{m.user_name || '—'}{m.note ? ` · ${m.note}` : ''}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ─────────────────────────── CONTEO FÍSICO ─────────────────────────── */
const REASONS = [['conteo', 'Ajuste de conteo'], ['rotura', 'Rotura'], ['regalo', 'Regalo / cortesía'], ['robo', 'Robo / faltante'], ['otro', 'Otro']];

function Conteo() {
  const api = useApi();
  const [count, setCount] = useState(null); // sesión abierta {id, lines}
  const [loading, setLoading] = useState(true);
  const [adj, setAdj] = useState(null); // línea en ajuste {line, reason, note}

  const loadOpen = async () => {
    setLoading(true);
    try {
      const list = await api.get('/api/inventory/counts').catch(() => []);
      const open = (Array.isArray(list) ? list : []).find(c => c.status === 'open');
      if (open) setCount(await api.get(`/api/inventory/counts/${open.id}`));
      else setCount(null);
    } finally { setLoading(false); }
  };
  useEffect(() => { loadOpen(); }, []); // eslint-disable-line

  async function iniciar() {
    const c = await api.post('/api/inventory/counts', {});
    setCount(await api.get(`/api/inventory/counts/${c.id}`));
  }
  async function setCounted(line, val) {
    const counted = val === '' ? null : Number(val);
    try {
      const upd = await api.patch(`/api/inventory/count-lines/${line.id}`, { counted });
      setCount(c => ({ ...c, lines: c.lines.map(l => l.id === line.id ? { ...l, counted: upd.counted, diff: upd.diff } : l) }));
    } catch (e) { alert(e.message); }
  }
  async function aplicarAjuste() {
    const { line, reason, note } = adj;
    if (!reason) return alert('Elegí un motivo');
    try {
      await api.post('/api/inventory/adjustments', { inventory_item_id: line.inventory_item_id, new_stock: line.counted, reason, note: note || null });
      setAdj(null);
      // refresca el stock actual de las líneas
      setCount(await api.get(`/api/inventory/counts/${count.id}`));
    } catch (e) { alert('No se pudo ajustar: ' + e.message); }
  }
  async function cerrar() {
    if (!window.confirm('¿Cerrar el conteo? Queda guardado como histórico.')) return;
    await api.patch(`/api/inventory/counts/${count.id}`, { status: 'closed' });
    setCount(null);
  }

  if (loading) return <div style={{ padding: '24px 0', color: 'var(--ink-600)', fontSize: 13 }}>Cargando…</div>;

  if (!count) return (
    <div className="lb-fade" style={{ marginTop: 18 }}>
      <p style={{ color: 'var(--ink-700)', fontSize: 13 }}>El conteo físico cruza lo que <b>debería</b> haber (según el sistema) contra lo que <b>contás</b> en la barra. La diferencia es el dato de fuga — el sistema <b>no la corrige solo</b>. Si reconciliás, queda registrado con motivo.</p>
      <button className="lb-btn lb-btn--primary" onClick={iniciar}>Iniciar conteo físico</button>
      <div style={{ marginTop: 10, fontSize: 11, color: 'var(--ink-600)' }}>Al abrir, se congela el stock actual de cada ítem como "teórico" (foto estable).</div>
      <MermaHistorica />
    </div>
  );

  const lines = count.lines || [];
  return (
    <div className="lb-fade" style={{ marginTop: 18 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ color: 'var(--ink-700)', fontSize: 13 }}>Conteo abierto · teórico = foto al iniciar. Cargá lo contado; la diferencia es la brecha.</div>
        <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={cerrar}>Cerrar conteo</button>
      </div>
      <div className="lb-card tk-scroll-x" style={{ padding: '6px 22px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '1.8fr 0.9fr 0.9fr 0.9fr 1fr' }}>
          <span>Ítem</span><span>Teórico</span><span>Contado</span><span>Diferencia</span><span></span>
        </div>
        {lines.length === 0 && <div style={{ padding: '22px 0', color: 'var(--ink-600)', fontSize: 13, textAlign: 'center' }}>No hay ítems activos para contar.</div>}
        {lines.map(l => {
          const diff = l.counted == null ? null : Number(l.counted) - Number(l.theoretical);
          const adjusted = l.counted != null && Number(l.current_stock) === Number(l.counted);
          return (
            <div key={l.id} className="lb-row" style={{ gridTemplateColumns: '1.8fr 0.9fr 0.9fr 0.9fr 1fr' }}>
              <span style={{ color: '#fff', fontWeight: 600 }}>{l.item_name} <span style={{ color: 'var(--ink-600)', fontSize: 12, fontWeight: 400 }}>({l.item_unit})</span></span>
              <span style={{ color: 'var(--ink-800)' }}>{Number(l.theoretical)}</span>
              <span><input className="lb-input" style={{ width: 80, padding: '6px 8px' }} inputMode="numeric" defaultValue={l.counted ?? ''} onBlur={e => setCounted(l, e.target.value)} /></span>
              <span style={{ color: diff == null ? 'var(--ink-600)' : diff < 0 ? 'var(--red-400)' : diff > 0 ? '#2ecc71' : 'var(--ink-700)', fontWeight: 600 }}>{diff == null ? '—' : (diff > 0 ? '+' : '') + diff}</span>
              <span style={{ textAlign: 'right' }}>
                {l.counted != null && diff !== 0 && !adjusted && <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setAdj({ line: l, reason: '', note: '' })}>Ajustar a lo contado</button>}
                {adjusted && <span style={{ fontSize: 11, color: '#2ecc71' }}>ajustado ✓</span>}
              </span>
            </div>
          );
        })}
      </div>
      <div style={{ marginTop: 10, fontSize: 11, color: 'var(--ink-600)' }}>"Ajustar" lleva el stock al valor contado y registra un movimiento con motivo (quién, cuándo, cuánto, por qué). La diferencia del conteo queda guardada como histórico de fuga.</div>

      <MermaHistorica />

      {adj && (
        <div className="lb-modal-backdrop" onClick={() => setAdj(null)}>
          <div className="lb-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 420, padding: 24 }}>
            <div className="lb-h" style={{ fontSize: 18, marginBottom: 4 }}>Ajustar "{adj.line.item_name}"</div>
            <div style={{ fontSize: 13, color: 'var(--ink-700)', marginBottom: 14 }}>Teórico {Number(adj.line.theoretical)} → contado <b style={{ color: '#fff' }}>{Number(adj.line.counted)}</b> (dif {Number(adj.line.counted) - Number(adj.line.theoretical)}). Elegí el motivo:</div>
            <select className="lb-select" value={adj.reason} onChange={e => setAdj({ ...adj, reason: e.target.value })}>
              <option value="">Motivo…</option>
              {REASONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
            <input className="lb-input" style={{ marginTop: 10 }} placeholder="Nota (opcional)" value={adj.note} onChange={e => setAdj({ ...adj, note: e.target.value })} />
            <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
              <button className="lb-btn lb-btn--primary lb-btn--block" onClick={aplicarAjuste} disabled={!adj.reason}>Aplicar ajuste</button>
              <button className="lb-btn lb-btn--ghost lb-btn--block" onClick={() => setAdj(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────── CONSUMO POR EVENTO ─────────────────────────── */
function Consumo() {
  const api = useApi();
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get('/api/events').then(r => { const e = Array.isArray(r) ? r : (r.events || []); setEvents(e); if (e[0]) setEventId(e[0].id); }).catch(() => {}); }, []); // eslint-disable-line
  useEffect(() => {
    if (!eventId) { setRows([]); return; }
    setLoading(true);
    api.get(`/api/inventory/consumption?event_id=${eventId}`).then(r => setRows(Array.isArray(r) ? r : [])).catch(() => setRows([])).finally(() => setLoading(false));
  }, [eventId]); // eslint-disable-line

  const totalCost = rows.reduce((a, r) => a + Number(r.consumed) * Number(r.cost || 0), 0);

  return (
    <div className="lb-fade" style={{ marginTop: 18 }}>
      <p style={{ color: 'var(--ink-700)', fontSize: 13, marginTop: 0 }}>Cuánto se consumió de cada ítem en un evento (según las ventas del TPV). Sirve para planificar el pedido de la próxima noche.</p>
      <select className="lb-select" style={{ maxWidth: 340, marginBottom: 18 }} value={eventId} onChange={e => setEventId(e.target.value)}>
        {events.length === 0 && <option value="">Sin eventos</option>}
        {events.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
      </select>
      <div className="lb-card tk-scroll-x" style={{ padding: '6px 22px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '2fr 1fr 1.2fr' }}>
          <span>Ítem</span><span>Consumido</span><span>Costo estimado</span>
        </div>
        {loading && <div style={{ padding: '20px 0', color: 'var(--ink-600)', fontSize: 13 }}>Cargando…</div>}
        {!loading && rows.length === 0 && <div style={{ padding: '22px 0', color: 'var(--ink-600)', fontSize: 13, textAlign: 'center' }}>No hubo consumo registrado en este evento.</div>}
        {rows.map(r => (
          <div key={r.id} className="lb-row" style={{ gridTemplateColumns: '2fr 1fr 1.2fr' }}>
            <span style={{ color: '#fff', fontWeight: 600 }}>{r.item_name}</span>
            <span style={{ color: 'var(--ink-800)' }}>{Number(r.consumed)} {r.unit}</span>
            <span style={{ color: 'var(--ink-800)' }}>{money(Number(r.consumed) * Number(r.cost || 0))}</span>
          </div>
        ))}
        {rows.length > 0 && (
          <div className="lb-row" style={{ gridTemplateColumns: '2fr 1fr 1.2fr', borderTop: '1px solid var(--border)' }}>
            <span style={{ color: 'var(--ink-700)' }}>Total</span><span></span>
            <span style={{ color: '#fff', fontWeight: 700 }}>{money(totalCost)}</span>
          </div>
        )}
      </div>
    </div>
  );
}

/* ─────────────────────────── ALERTAS DE REPOSICIÓN ─────────────────────────── */
function Alertas() {
  const api = useApi();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get('/api/inventory/alerts').then(r => setRows(Array.isArray(r) ? r : [])).catch(() => {}).finally(() => setLoading(false)); }, []); // eslint-disable-line

  return (
    <div className="lb-fade" style={{ marginTop: 18 }}>
      <p style={{ color: 'var(--ink-700)', fontSize: 13, marginTop: 0 }}>Ítems en o por debajo de su punto de alerta. Pedí para la próxima noche.</p>
      {loading && <div style={{ color: 'var(--ink-600)', fontSize: 13 }}>Cargando…</div>}
      {!loading && rows.length === 0 && <div className="lb-card" style={{ padding: 22, textAlign: 'center', color: '#2ecc71', fontSize: 13 }}>✓ Todo el stock está por encima del punto de alerta.</div>}
      {rows.length > 0 && (
        <div className="lb-card tk-scroll-x" style={{ padding: '6px 22px' }}>
          <div className="lb-row lb-th" style={{ gridTemplateColumns: '2fr 1fr 1fr 1fr' }}>
            <span>Ítem</span><span>Stock</span><span>Alerta</span><span>Falta</span>
          </div>
          {rows.map(it => (
            <div key={it.id} className="lb-row" style={{ gridTemplateColumns: '2fr 1fr 1fr 1fr' }}>
              <span style={{ color: '#fff', fontWeight: 600 }}>{it.name} <span style={{ color: 'var(--ink-600)', fontSize: 12, fontWeight: 400 }}>({it.unit})</span></span>
              <span style={{ color: 'var(--red-400)', fontWeight: 600 }}>{Number(it.stock)}</span>
              <span style={{ color: 'var(--ink-700)' }}>{Number(it.reorder_point)}</span>
              <span style={{ color: 'var(--ink-800)' }}>{Math.max(0, Number(it.reorder_point) - Number(it.stock))}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ─────────── Diferencia histórica de conteo (merma promedio) ─────────── */
function MermaHistorica() {
  const api = useApi();
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get('/api/inventory/count-stats').then(setStats).catch(() => {}); }, []); // eslint-disable-line
  if (!stats) return null;
  return (
    <div style={{ marginTop: 26 }}>
      <div className="lb-eyebrow" style={{ marginBottom: 10 }}>Diferencia histórica de conteo</div>
      <div className="lb-card" style={{ padding: '18px 22px', display: 'flex', alignItems: 'center', gap: 18, flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 34, color: stats.mermaPct > 0 ? 'var(--red-400)' : '#2ecc71' }}>{stats.mermaPct}%</div>
          <div className="lb-eyebrow">Merma promedio</div>
        </div>
        <div style={{ flex: 1, minWidth: 220, fontSize: 12, color: 'var(--ink-700)' }}>
          {stats.conteos > 0
            ? <>Diferencia promedio entre lo teórico y lo realmente contado, sobre {stats.conteos} conteo{stats.conteos === 1 ? '' : 's'}. Si no podés contar antes de una noche, restale este % al stock del sistema para estimar lo real.</>
            : <>Todavía no hay conteos cargados. A medida que hagas conteos físicos, acá vas a ver el % promedio de fuga entre lo teórico y lo real.</>}
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────── PROVEEDORES ─────────────────────────── */
function Proveedores() {
  const api = useApi();
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ name: '', phone: '' });
  const [editing, setEditing] = useState(null);
  const [err, setErr] = useState('');

  const load = () => api.get('/api/inventory/suppliers').then(r => setList(Array.isArray(r) ? r : [])).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  async function create() {
    setErr('');
    if (!form.name.trim()) { setErr('Poné un nombre'); return; }
    try { await api.post('/api/inventory/suppliers', { name: form.name.trim(), phone: form.phone.trim() || null }); setForm({ name: '', phone: '' }); load(); }
    catch (e) { setErr(e.message || 'No se pudo crear'); }
  }
  async function saveEdit() {
    try { await api.patch(`/api/inventory/suppliers/${editing.id}`, { name: editing.name, phone: editing.phone || null }); setEditing(null); load(); }
    catch (e) { alert(e.message); }
  }
  async function baja(s) {
    if (!window.confirm(`¿Dar de baja al proveedor "${s.name}"?`)) return;
    try { await api.del(`/api/inventory/suppliers/${s.id}`); load(); } catch (e) { alert(e.message); }
  }

  return (
    <div className="lb-fade" style={{ marginTop: 18 }}>
      <p style={{ color: 'var(--ink-700)', fontSize: 13, marginTop: 0 }}>Proveedores a los que se les hace el pedido. El teléfono se usa para enviar el pedido por WhatsApp (incluí el código de país, ej. 549351…).</p>
      <div className="lb-card" style={{ padding: '18px 20px', marginBottom: 22 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1.2fr auto', gap: 10, alignItems: 'end' }}>
          <Field label="Nombre"><input className="lb-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Distribuidora X" /></Field>
          <Field label="Teléfono (WhatsApp)"><input className="lb-input" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="5493510000000" /></Field>
          <button className="lb-btn lb-btn--primary" onClick={create}>Agregar</button>
        </div>
        {err && <div className="lb-err" style={{ marginTop: 10 }}>{err}</div>}
      </div>
      <div className="lb-card tk-scroll-x" style={{ padding: '6px 22px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '1.8fr 1.2fr 0.9fr' }}>
          <span>Proveedor</span><span>Teléfono</span><span></span>
        </div>
        {list.length === 0 && <div style={{ padding: '24px 0', color: 'var(--ink-600)', fontSize: 13, textAlign: 'center' }}>Todavía no hay proveedores. Agregá el primero arriba.</div>}
        {list.map(s => (
          <div key={s.id} className="lb-row" style={{ gridTemplateColumns: '1.8fr 1.2fr 0.9fr', opacity: s.active ? 1 : 0.5 }}>
            <span style={{ color: '#fff', fontWeight: 600 }}>{s.name}{!s.active && <span style={{ color: 'var(--ink-600)', fontWeight: 400 }}> · baja</span>}</span>
            <span style={{ color: 'var(--ink-700)' }}>{s.phone || '—'}</span>
            <span style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setEditing({ ...s })}>Editar</button>
              {s.active && <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => baja(s)}>Baja</button>}
            </span>
          </div>
        ))}
      </div>

      {editing && (
        <div className="lb-modal-backdrop" onClick={() => setEditing(null)}>
          <div className="lb-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 420, padding: 24 }}>
            <div className="lb-h" style={{ fontSize: 18, marginBottom: 14 }}>Editar proveedor</div>
            <Field label="Nombre"><input className="lb-input" value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} /></Field>
            <div style={{ marginTop: 10 }}><Field label="Teléfono (WhatsApp)"><input className="lb-input" value={editing.phone || ''} onChange={e => setEditing({ ...editing, phone: e.target.value })} /></Field></div>
            <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
              <button className="lb-btn lb-btn--primary lb-btn--block" onClick={saveEdit}>Guardar</button>
              <button className="lb-btn lb-btn--ghost lb-btn--block" onClick={() => setEditing(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────── PEDIDOS ─────────────────────────── */
function Pedidos() {
  const api = useApi();
  const [menus, setMenus] = useState([]);
  const [menuId, setMenuId] = useState('');
  const [people, setPeople] = useState('');
  const [applyMerma, setApplyMerma] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => { api.get('/api/tpv/menus').then(r => { const m = Array.isArray(r) ? r : []; setMenus(m); if (m[0]) setMenuId(m[0].id); }).catch(() => {}); }, []); // eslint-disable-line

  async function calcular() {
    setErr(''); setData(null);
    if (!menuId) { setErr('Elegí un menú'); return; }
    if (!(Number(people) > 0)) { setErr('Poné la cantidad de gente esperada'); return; }
    setLoading(true);
    try {
      const r = await api.get(`/api/inventory/order-estimate?menu_id=${menuId}&people=${Number(people)}&apply_merma=${applyMerma ? 1 : 0}`);
      setData(r);
    } catch (e) { setErr(e.message || 'No se pudo calcular'); } finally { setLoading(false); }
  }

  function hacerPedido(g) {
    const venue = '';
    const lineas = g.items.map(it => `• ${it.item_name}: ${it.order} ${it.unit}`).join('\n');
    const msg = `Hola${g.supplier_name ? ' ' + g.supplier_name : ''}! Te paso el pedido:\n${lineas}\n\nGracias!`;
    const phone = String(g.supplier_phone || '').replace(/\D/g, '');
    if (!phone) { alert('Este proveedor no tiene teléfono cargado. Agregalo en el tab Proveedores.'); return; }
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, '_blank');
  }

  return (
    <div className="lb-fade" style={{ marginTop: 18 }}>
      <p style={{ color: 'var(--ink-700)', fontSize: 13, marginTop: 0 }}>Elegí el menú y la gente que esperás. El sistema calcula —del histórico de ese menú— el consumo por persona, lo proyecta (×1,25 de seguridad), lo convierte a ítems, le resta el stock y te arma el pedido agrupado por proveedor.</p>
      <div className="lb-card" style={{ padding: '18px 20px', marginBottom: 22 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr auto', gap: 12, alignItems: 'end' }}>
          <Field label="Menú a vender">
            <select className="lb-select" value={menuId} onChange={e => setMenuId(e.target.value)}>
              {menus.length === 0 && <option value="">Sin menús</option>}
              {menus.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
            </select>
          </Field>
          <Field label="Gente esperada"><input className="lb-input" inputMode="numeric" value={people} onChange={e => setPeople(e.target.value.replace(/\D/g, ''))} placeholder="500" /></Field>
          <button className="lb-btn lb-btn--primary" onClick={calcular} disabled={loading}>{loading ? 'Calculando…' : 'Calcular pedido'}</button>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 14, fontSize: 13, color: 'var(--ink-700)', cursor: 'pointer' }}>
          <input type="checkbox" checked={applyMerma} onChange={e => setApplyMerma(e.target.checked)} />
          Descontar merma histórica del stock (cuando no pudiste hacer el conteo)
        </label>
        {err && <div className="lb-err" style={{ marginTop: 10 }}>{err}</div>}
      </div>

      {data && !data.hasHistory && (
        <div className="lb-card" style={{ padding: 22, textAlign: 'center', color: 'var(--ink-600)', fontSize: 13 }}>
          No hay historial de ventas para este menú todavía (ventas en eventos con gente registrada). Vendé al menos una noche con este menú para poder estimar.
        </div>
      )}

      {data && data.hasHistory && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
          <div style={{ fontSize: 12, color: 'var(--ink-600)' }}>
            Base: {data.eventos} noche{data.eventos === 1 ? '' : 's'} · {data.totalPeople} personas históricas · coef. seguridad ×{data.safety}
            {data.appliedMerma ? ` · stock ajustado por merma ${data.mermaPct}%` : ''}
          </div>

          {data.groups.length === 0 && (
            <div className="lb-card" style={{ padding: 22, textAlign: 'center', color: '#2ecc71', fontSize: 13 }}>✓ Con el stock actual te alcanza: no hay que pedir nada.</div>
          )}

          {data.groups.map((g, gi) => (
            <div key={gi}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, flexWrap: 'wrap', gap: 10 }}>
                <div className="lb-eyebrow">{g.supplier_name || 'Sin proveedor asignado'}{g.supplier_phone ? ` · ${g.supplier_phone}` : ''}</div>
                {g.supplier_id
                  ? <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={() => hacerPedido(g)}>Hacer pedido por WhatsApp →</button>
                  : <span style={{ fontSize: 11, color: 'var(--ink-600)' }}>Asigná un proveedor a estos ítems para enviar el pedido</span>}
              </div>
              <div className="lb-card tk-scroll-x" style={{ padding: '6px 22px' }}>
                <div className="lb-row lb-th" style={{ gridTemplateColumns: '2.4fr 1fr' }}><span>Ítem</span><span>Pedir</span></div>
                {g.items.map((it, i) => (
                  <div key={i} className="lb-row" style={{ gridTemplateColumns: '2.4fr 1fr' }}>
                    <span style={{ color: '#fff', fontWeight: 600 }}>{it.item_name}</span>
                    <span style={{ color: 'var(--red-400)', fontWeight: 700 }}>{it.order} {it.unit}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {data.sinReceta && data.sinReceta.length > 0 && (
            <div style={{ fontSize: 12, color: 'var(--ink-600)' }}>
              Productos vendidos sin receta cargada (no se pueden convertir a ítem para el pedido): {data.sinReceta.map(s => s.product).join(', ')}. Cargales la receta en el tab Recetas.
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function Field({ label, children }) {
  return <div className="lb-field"><div className="lb-label">{label}</div>{children}</div>;
}
